import { FC } from 'react';

import { Membership } from '@bpm-web-app/supreme-api-sdk';
import { formatDateToString } from '@bpm-web-app/utils';
import { usePreviewResumeSubscription } from '@bpm-web-app/swr-hooks';
import { Button } from '../../../components/button/button';
import { Modal } from '../../../components/modal/modal';
import accountStyles from '../../../account.module.css';
import planStyles from '../your-plan.module.css';
import styles from './resume-button.module.css';
import { useResume } from './use-resume';

type Props = {
    membership: Membership
};

export const ResubscribeButton: FC<Props> = ({ membership }) => {
    const { isConfirmationOpen, setConfirmationOpen, platform, resumeSubscription, isLoading } = useResume();
    const { data, error } = usePreviewResumeSubscription(platform);

    return (
        <>
            <Button type="button" onClick={() => setConfirmationOpen(true)} className={planStyles['plan__button']}>
                Resubscribe
            </Button>

            <Modal
                title="Resubscribe"
                isOpen={isConfirmationOpen}
                onClose={() => setConfirmationOpen(false)}
            >
                <p className={styles['description-text']}>
                    Next payment of ${membership.subscription?.package?.amount} will be on {data ? formatDateToString(data?.renews_at, 'L') : <span className={accountStyles['loading-wrapper']}>00/00/0000</span>}, when your plan renews.
                </p>

                {!!error && (
                    <p className={styles['preview-error']}>{error}</p>
                )}

                <Button
                    type="button"
                    variant="primary"
                    isLoading={isLoading}
                    disabled={!!error}
                    onClick={resumeSubscription}
                    className={styles['confirm-button']}
                >
                    Resubscribe
                </Button>
            </Modal>
        </>
    );
};
